import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import SupplierListView from 'src/sections/supplier/view/supplier-list-view';

export default function SuppliersListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Suppliers</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_SUPPLIER,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <SupplierListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
